import Factory from './factory';

export default new Factory();
